
import * as React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, Chip, Divider, FormControl, Grid, IconButton, InputLabel, LinearProgress, List, ListItem, ListItemText, MenuItem, Popper, Select, Stack, TextField, Toolbar, Tooltip, useMediaQuery } from '@mui/material';
import BasicBars from '../components/Common/Chart';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboardData } from '../store/platformSlice';
import { CloseRounded } from '@mui/icons-material';
import { capitalizeWords, DATE_FILTER } from '../utils/constant';
import moment from 'moment/moment';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import { DemoContainer, DemoItem } from '@mui/x-date-pickers/internals/demo';

import { DateField } from '@mui/x-date-pickers/DateField';
import { TimeField } from '@mui/x-date-pickers/TimeField';
import { DateTimeField } from '@mui/x-date-pickers/DateTimeField';
import BasicPopover from '../components/Common/PopOver';

export default function DashBoard() {

  const dispatch = useDispatch()
  const dashboardStatics = useSelector((state) => state.platformReducer.dashboardStatics)
  // const loading = true
  const loading = useSelector((state) => state.platformReducer.loading)
  const [selectedFilter, setSelectedFilter] = React.useState("last_week")
  const today = moment();
  const sevenDaysAgo = moment().subtract(7, 'days');
  const [startDate, setStartDate] = React.useState();
  const [endDate, setEndDate] = React.useState();
  // const [startDate, setStartDate] = React.useState(moment().subtract(7, 'days').toISOString());
  // const [endDate, setEndDate] = React.useState(moment().toISOString());
  const isMobile = useMediaQuery('(max-width:600px)');

  React.useEffect(() => {
    const today = moment();
    let startDate, endDate;


    switch (selectedFilter) {
      case 'today':
        startDate = today.clone().startOf('day').format('YYYY-MM-DDT00:00:00');
        endDate = today.clone().endOf('day').format('YYYY-MM-DDT11:59:59');
        break;
      case 'yesterday':
        startDate = today.clone().subtract(1, 'day').startOf('day').format('YYYY-MM-DDT00:00:00');
        endDate = today.clone().subtract(1, 'day').endOf('day').format('YYYY-MM-DDT11:59:59');
        break;
      case 'last_week':
        startDate = today.clone().subtract(6, 'days').startOf('day').format('YYYY-MM-DDT00:00:00');
        endDate = today.clone().endOf('day').format('YYYY-MM-DDT11:59:59');
        break;
      case 'last_month':
        startDate = today.clone().subtract(1, 'month').startOf('day').format('YYYY-MM-DDT00:00:00');
        endDate = today.clone().endOf('day').format('YYYY-MM-DDT11:59:59');
        break;
      case 'last_year':
        startDate = today.clone().subtract(1, 'year').startOf('day').format('YYYY-MM-DDT00:00:00');
        endDate = today.clone().endOf('day').format('YYYY-MM-DDT11:59:59');
        break;
      default:
        startDate = today.clone().startOf('day').format('YYYY-MM-DDT00:00:00');
        endDate = today.clone().endOf('day').format('YYYY-MM-DDT11:59:59');
    }

    setStartDate(startDate)
    setEndDate(endDate)
  

  }, [selectedFilter]);

  const CustomActionBar = ({ onClear, onAccept }) => {
    return (
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          justifyContent: 'flex-end',
          position: 'absolute',
          bottom: 0,
          px: 2,
          pt: 1,
          pb: 2,
          mt: 'auto', // push to bottom
        }}
      >
        <Stack direction="row" spacing={1}>
          <Button size="small" variant="contained" onClick={onAccept}>Reset</Button>
        </Stack>
      </Box>
    );
  };


  React.useEffect(() => {
    if (startDate && endDate) {
      dispatch(getDashboardData({ startDate, endDate }));
    }
  }, [startDate, endDate]);


  return (
    <>
      <Toolbar
        className='main-list-toolbar'
        sx={{ flexWrap: 'wrap', gap: 1 }}
      >
        <Typography
          className="d-flex flex-grow-1 flex-shrink-1 flex-fill"
          variant="h6"
          id="tableTitle"
          component="div"
        >
          Dashboard
        </Typography>

        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Stack direction="row" spacing={1}>
            <DatePicker
              label="Start Date"
              value={moment(startDate)}
              onChange={(date) => {
                // console.log("ddddd", moment(date).toISOString());

                if (moment(date).isValid()) {
                  // console.log("validating");

                  setStartDate(moment(date).toISOString()); // store as ISO string
                }
              }}
              maxDate={moment(endDate)}
              format="YYYY-MM-DD"


              slots={{
                actionBar: CustomActionBar,
              }}
              slotProps={{
                textField: {
                  size: 'small',
                },

                actionBar: {
                  onAccept: () => {
                    let startDate = today.clone().subtract(6, 'days').startOf('day').format('YYYY-MM-DDT00:00:00');
                    setStartDate(startDate);
                  },
                },
              }}

            />
            <DatePicker
              label="End Date"
              value={moment(endDate)}
              onChange={(date) => {
                const validDate = moment(date);
                // console.log("validDate", validDate);
                if (validDate.isValid()) {
                  setEndDate(validDate.toISOString());
                }
              }}
              minDate={moment(startDate)}
              maxDate={moment(endDate)}
              format="YYYY-MM-DD"
              slots={{
                actionBar: CustomActionBar,
              }}
              slotProps={{
                textField: {
                  size: 'small',
                },

                actionBar: {
                  onAccept: () => {
                    const endDate = today.clone().endOf('day').format('YYYY-MM-DDT11:59:59');
                    setEndDate(endDate);
                  },
                },
              }}
            />
          </Stack>
        </LocalizationProvider>
        <FormControl fullWidth={isMobile} className={`${isMobile ? 'mt-1' : 'mt-3'}  mb-3`} sx={{ minWidth: 170 }}>
          <InputLabel id="date_range">Date Range</InputLabel>
          <Select
            labelId="date_range"
            id="date_range"
            name='date_range'
            label="Date Range"
            size='small'
            value={selectedFilter}
            onChange={(e) => {

              setSelectedFilter(e.target.value)
            }}
          >
            {DATE_FILTER?.length && DATE_FILTER?.map((ele) => (
              <MenuItem key={ele?.key} value={ele?.key}>{ele?.name}</MenuItem>
            ))}
          </Select>
        </FormControl>

      </Toolbar>
      <Box className='pb-4'>
      <Grid container spacing={2} sx={{ width: '100%', margin: 0 }}>
        {[
          { title: 'Leads By Platform', data: dashboardStatics?.by_platform, keyName: 'platform' },
          { title: 'Leads by Industry', data: dashboardStatics?.by_industry, keyName: 'industry' },
          { title: 'Leads by Search Keyword', data: dashboardStatics?.by_search_keyword, keyName: 'search_keyword' },
        ].map(({ title, data, keyName }, index) => (


          <Grid
            // size={{ lg: 4, md: 4, sm: 12, xs: 12 }}
            lg={4} md={4} sm={12} xs={12}
            sx={{padding:isMobile?'10px 0px':''}}
            key={index} >
            {loading && <LinearProgress sx={{ mx: 1 }} />}
            <Card
              variant="outlined"
              className="dashboard-card-wrapper"
              sx={{ height: '100%', mx: 1 }}
            >
              <Typography
                variant="body1"
                className="font-weight-bold pt-3 pl-3"
                gutterBottom
                color="primary"
              >
                {title}
              </Typography>
              <CardContent>
                <TableContainer component={Paper} sx={{ height: '100%' }}>
                  <Table size="small" aria-label="a dense table">
                    <TableBody>
                      {
                        title !== 'Leads by Search Keyword' &&
                        data?.map((row, i) => {
                          // console.log("row", row);

                          return (
                            <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                              <TableCell align="left"  >{row[keyName]}</TableCell>
                              <TableCell align="right">{row.count}</TableCell>
                            </TableRow>
                          )
                        })
                      }

                      {title === 'Leads by Search Keyword' &&
                        <>
                          {data?.map((row, i) => {
                            return (
                              <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                <TableCell align="left">
                                  {(() => {
                                    const keywords = row[keyName]?.split(',').map(k => k.trim()).filter(Boolean);
                                    const first = keywords?.[0];
                                    const remaining = keywords?.slice(1);

                                    if (remaining.length > 0) {
                                      return (
                                        <Box textTransform={"capitalize"}>
                                          <span style={{ marginRight: '15px' }}>
                                            {first}
                                          </span>
                                          <BasicPopover length={remaining?.length}>
                                            <List disablePadding dense className='location-list'>
                                              {remaining.map((e, i) => (
                                                <ListItem key={i} disableGutters>
                                                  <ListItemText
                                                    primary={
                                                      <Typography color='primary' textTransform={"capitalize"} variant='body2'>{(i + 1)}. {e}</Typography>
                                                    }
                                                  />
                                                </ListItem>
                                              ))}
                                            </List>
                                          </BasicPopover>
                                        </Box>
                                      );
                                    }
                                    return first || '-';
                                  })()}

                                </TableCell>
                                <TableCell align="right">{row.count}</TableCell>
                              </TableRow>
                            )
                          })}

                        </>
                      }
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>

        ))}
      </Grid>
      <Grid container spacing={2} sx={{ width: '100%', margin: 0, mt:!isMobile?'16px':'0' }} >
        {[
          { title: 'Leads By Type', data: dashboardStatics?.leads_by_comment_type, keyName: 'comment_type' },
          { title: 'Leads Sold to Client', data: dashboardStatics?.sold_by_client, keyName: 'email' },

        ].map(({ title, data, keyName }, index) => (
          <Grid lg={4} md={4} sm={12} xs={12} key={index} sx={{padding:isMobile?'10px 0px':''}}>
            {loading && <LinearProgress sx={{ mx: 1 }} />}
            <Card
              variant="outlined"
              className="dashboard-card-wrapper"
              sx={{ height: '100%', mx: 1,  }}
            >
              <Typography
                variant="body1"
                className="font-weight-bold pt-3 pl-3"
                gutterBottom
                color="primary"
              >
                {title}
              </Typography>
              <CardContent>
                <TableContainer component={Paper} sx={{ height: '100%' }}>
                  <Table size="small" aria-label="a dense table">
                    <TableBody>
                      {data?.map((row, i) => (
                        <TableRow key={i} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                          <TableCell align="left">{keyName !== "email" ? capitalizeWords(row[keyName]) : row[keyName]}</TableCell>
                          <TableCell align="right">{row.count}</TableCell>
                        </TableRow>
                      ))}
                     { keyName=== 'comment_type'&&<TableRow>
                        <TableCell align="left" ><span style={{fontWeight:600}}>Total</span></TableCell>
                        <TableCell align="right"><span style={{fontWeight:600}}>{dashboardStatics.total_leads}</span></TableCell>
                      </TableRow>}
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        ))}
      </Grid>
      </Box>
    </>
  );
}
